<app-auth-layout
    [showWide]="true"
>
    <app-h3>Contact Us</app-h3>

    <form 
        *ngIf="stateService.formGroup$ | async as formGroup"
        [formGroup]="formGroup"
        (ngSubmit)="onSubmit()"
        tid="contact-us-form"
    >
        <div class="row">
            <div class="col-md-6 mb-3">
                <app-input
                    formPropertyName="name"
                    label="Name"
                    placeholder="Enter name"
                    [requiredField]="true"
                    tid="name"
                ></app-input>
            </div>

            <div class="col-md-6 mb-3">
                <app-input
                    formPropertyName="companyName"
                    label="Company Name"
                    placeholder="Enter company name"
                    [requiredField]="true"
                    tid="company-name"
                ></app-input>
            </div>

            <div class="col-md-6 mb-3">
                <app-input
                    formPropertyName="contactEmail"
                    label="Contact Email"
                    type="email"
                    placeholder="Enter contact email"
                    [requiredField]="true"
                    tid="contact-email"
                ></app-input>
            </div>

            <div class="col-md-6 mb-3">
                <app-input
                    formPropertyName="contactTelephone"
                    label="Contact Telephone"
                    placeholder="Enter contact telephone"
                    [requiredField]="true"
                    [maxLength]="11"
                    [minLength]="10"
                    tid="contact-telephone"
                ></app-input>
            </div>

            <div class="col-md-12 mb-3">
                <app-input
                    formPropertyName="reason"
                    label="Reason for Contact"
                    type="text-area"
                    placeholder="Enter reason for contact"
                    [requiredField]="true"
                    [maxLength]="500"
                    tid="reason"
                ></app-input>
            </div>
        </div>

        <div class="footer-actions">
            <div>   
                <app-button 
                    theme="alternate" 
                    [loading]="(stateService.state$ | async)?.inFlight" 
                    (click)="return()"
                    tid="back-button"
                >Back</app-button>
            </div>
            <div>
                <app-button 
                    theme="primary" 
                    [loading]="(stateService.state$ | async)?.inFlight" 
                    (click)="onSubmit()"
                    tid="contact-submit-button"
                    >Submit
                </app-button>
            </div>
        </div>
    </form>
</app-auth-layout>
